/* tslint:disable */
/* eslint-disable */
/**
 * Oil refinery process modeling system
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.4
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {mapValues} from '../runtime';
/**
 *
 * @export
 * @interface PseudoComponentOut
 */
export interface PseudoComponentOut {
  /**
   *
   * @type {string}
   * @memberof PseudoComponentOut
   */
  uuid: string;
  /**
   *
   * @type {string}
   * @memberof PseudoComponentOut
   */
  name: string;
  /**
   *
   * @type {string}
   * @memberof PseudoComponentOut
   */
  value: string;
}

/**
 * Check if a given object implements the PseudoComponentOut interface.
 */
export function instanceOfPseudoComponentOut(value: object): value is PseudoComponentOut {
  if (!('uuid' in value) || value['uuid'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function PseudoComponentOutFromJSON(json: any): PseudoComponentOut {
  return PseudoComponentOutFromJSONTyped(json, false);
}

export function PseudoComponentOutFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PseudoComponentOut {
  if (json == null) {
    return json;
  }
  return {
    uuid: json['uuid'],
    name: json['name'],
    value: json['value']
  };
}

export function PseudoComponentOutToJSON(value?: PseudoComponentOut | null): any {
  if (value == null) {
    return value;
  }
  return {
    uuid: value['uuid'],
    name: value['name'],
    value: value['value']
  };
}
